/* hoh-hero-data.js · R795 · the hero page's only data layer.

   Every door is the R795 contract's (docs/R795-HERO-PAGES-CONTRACT.md), called
   the way the Hall calls its doors: PostgREST RPC on the Hall's own Supabase
   project with the publishable key the Hall already ships (read from the
   section's #hhp-config, never repeated here). Account doors take the Hall
   account's email and PIN from the same localStorage token the Hall writes.

   Nothing here decides a hero's rarity. The server scores and stores it; the
   page shows the server's tier and points. The judge and the planner below are
   the approved prototype's (hub d-core.js), ported so the fill can say "this
   counts" while the player types and "3 more until Rare" between answers. The
   server runs the same checks on every save and its answer wins.

   window.HHD is the whole public surface. No other file talks to the network
   for the hero page (hoh-data.js keeps its own favourites and tickets client,
   reused as is through the small hohSupabaseClient.rpc shim below). */
(function(){
  'use strict';
  if(typeof window === 'undefined' || window.HHD) return;

  /* ---------------------------------------------------------------- config */
  var CFG = {};
  try { var el = document.getElementById('hhp-config'); CFG = JSON.parse(el ? el.textContent : '{}') || {}; } catch(_){ CFG = {}; }
  CFG.supabaseUrl = String(CFG.supabaseUrl || '').replace(/\/+$/, '');
  CFG.workerUrl = String(CFG.workerUrl || '').replace(/\/+$/, '');
  CFG.site = String(CFG.site || 'https://framedfantasy.com').replace(/\/+$/, '');
  CFG.links = CFG.links || {};
  CFG.assets = CFG.assets || {};

  /* ---------------------------------------------------------------- helpers */
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function has(v){ return v != null && String(v).trim() !== ''; }
  function clamp(v, a, b, d){ v = Number(v); return isFinite(v) ? Math.max(a, Math.min(b, v)) : d; }
  function plural(n, one, many){ return n === 1 ? one : many; }
  function hash(s){ var h = 2166136261; s = String(s); for(var i = 0; i < s.length; i++){ h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  /* https only, plus the local fixture server during QA */
  function safeUrl(v){
    if(!has(v)) return '';
    try {
      var u = new URL(String(v).trim(), location.href);
      if(u.protocol === 'https:') return u.href;
      if(u.protocol === 'http:' && /^(127\.0\.0\.1|localhost)$/.test(u.hostname)) return u.href;
    } catch(_){}
    return '';
  }
  function firstName(n){ var f = String(n || '').trim().split(/\s+/)[0] || ''; return f ? f.charAt(0).toUpperCase() + f.slice(1) : 'This hero'; }
  function poss(n){ return /s$/i.test(n) ? n + "'" : n + "'s"; }
  function fillN(t, name){ var N = firstName(name); return String(t || '').replace(/\{N\}'s/g, poss(N)).replace(/\{N\}/g, N); }
  function joinAnd(a){ return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  var store = {
    get: function(k, d){ try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch(_){ return d; } },
    set: function(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch(_){ return false; } },
    del: function(k){ try { localStorage.removeItem(k); } catch(_){} }
  };
  var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  function uuid(){
    try { if(crypto && crypto.randomUUID) return crypto.randomUUID(); } catch(_){}
    var b = new Uint8Array(16);
    try { crypto.getRandomValues(b); } catch(_){ for(var i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256); }
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function(x){ return (x + 256).toString(16).slice(1); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }

  /* ---------------------------------------------------------------- account */
  /* The Hall's own session (hoh-your-hall.js): email, PIN and savedAt, a year, sliding. */
  var TOKEN_KEY = 'hoh-your-hall-token', EMAIL_KEY = 'hoh-your-hall-email', YEAR = 365 * 864e5;
  function token(){
    try {
      var t = JSON.parse(localStorage.getItem(TOKEN_KEY) || 'null');
      if(!t || !t.email || !t.pin || !t.savedAt) return null;
      if(Date.now() - t.savedAt > YEAR) return null;
      return { email: String(t.email).trim().toLowerCase(), pin: String(t.pin) };
    } catch(_){ return null; }
  }
  function saveToken(email, pin){
    var old = {};
    try { old = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}') || {}; } catch(_){}
    try {
      localStorage.setItem(TOKEN_KEY, JSON.stringify({ email: email, pin: pin, savedAt: Date.now(), phone: !!old.phone }));
      localStorage.setItem(EMAIL_KEY, email);
    } catch(_){ return false; }
    try { document.dispatchEvent(new CustomEvent('hoh:signed-in', { detail: { source: 'hero-page' } })); } catch(_){}
    return true;
  }
  /* The Hall's email-only sign-in (hohYourHallSetEmailOnly, after a submit
     with no PIN) leaves the email and no PIN. It is a hint for the forms,
     never an identity: every owner door still wants the PIN. */
  function storedEmail(){
    try { var t = JSON.parse(localStorage.getItem(TOKEN_KEY) || 'null'); if(t && t.email) return String(t.email).trim().toLowerCase(); } catch(_){}
    try { return String(localStorage.getItem(EMAIL_KEY) || '').trim().toLowerCase(); } catch(_){ return ''; }
  }

  /* ---------------------------------------------------------------- network */
  function sbHeaders(){ return { 'Content-Type': 'application/json', 'apikey': CFG.supabaseKey, 'Authorization': 'Bearer ' + CFG.supabaseKey }; }
  /* one request, one plain answer: {status, json} or {network:true} */
  function send(url, opt){
    opt = opt || {};
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function(){ try { ctl && ctl.abort(); } catch(_){} }, opt.timeout || 15000);
    var init = { method: opt.method || 'POST', headers: opt.headers || sbHeaders(), signal: ctl ? ctl.signal : undefined };
    if(opt.body != null) init.body = (typeof opt.body === 'string' || (typeof FormData !== 'undefined' && opt.body instanceof FormData)) ? opt.body : JSON.stringify(opt.body);
    return fetch(url, init).then(function(res){
      return res.text().then(function(txt){
        clearTimeout(timer);
        var j = null; try { j = txt ? JSON.parse(txt) : null; } catch(_){ j = null; }
        return { status: res.status, json: j };
      });
    }, function(){ clearTimeout(timer); return { status: 0, json: null, network: true }; });
  }
  /* The same test hoh-data.js uses: a schema-cache miss that names THIS function. */
  function isMissing(err, fn){
    if(!err) return false;
    var code = String(err.code || '').toUpperCase();
    var safe = String(fn).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if(code === 'PGRST202'){
      var text = [err.message, err.details, err.hint].join(' ');
      return new RegExp('(?:^|[^a-z0-9_])(?:public\\.)?' + safe + '(?:[^a-z0-9_]|$)', 'i').test(text) && /could not find|schema cache/i.test(text);
    }
    if(code === '42883'){
      return new RegExp('\\bfunction\\s+(?:(?:"?public"?)\\.)?"?' + safe + '"?(?:\\s*\\([^\\n]{0,512}\\))?\\s+does not exist\\b', 'i').test(String(err.message || ''));
    }
    return false;
  }
  function interpretRaw(r, fn){
    if(r.network) return { ok: false, network: true, reason: 'network' };
    if(r.status >= 200 && r.status < 300) return { ok: true, data: r.json, status: r.status };
    var err = (r.json && typeof r.json === 'object') ? r.json : {};
    if(isMissing(err, fn)) return { ok: false, missing: true, reason: 'not_installed', status: r.status, error: err };
    return { ok: false, reason: String(err.code || ('http_' + r.status)), status: r.status, error: err, message: String(err.message || ''), network: !err.code && r.status >= 500 };
  }
  function call(fn, args, opt){
    return send(CFG.supabaseUrl + '/rest/v1/rpc/' + fn, { body: args || {}, timeout: (opt && opt.timeout) || 15000 }).then(function(r){ return interpretRaw(r, fn); });
  }
  /* a JSON door that answers {ok, ...} or {ok:false, reason} */
  function interpretDoor(r){
    if(!r.ok) return r;
    var d = r.data; if(Array.isArray(d)) d = d[0] || null;
    if(!d || typeof d !== 'object') return { ok: false, reason: 'empty', data: d };
    if(d.ok === false) return { ok: false, reason: String(d.reason || 'refused'), data: d };
    return { ok: true, data: d };
  }
  function door(fn, args, opt){ return call(fn, args, opt).then(interpretDoor); }
  function get(path){
    return send(CFG.supabaseUrl + '/rest/v1/' + path, { method: 'GET', headers: { 'apikey': CFG.supabaseKey, 'Authorization': 'Bearer ' + CFG.supabaseKey } });
  }

  /* hoh-data.js (the Hall's favourites and tickets client) calls
     window.hohSupabaseClient.rpc and wants {data, error} back. The hero page
     does not load supabase-js, so it gets this small stand-in. A failed
     request without a PostgREST code stays codeless: that client reads a
     codeless error as a network miss, which proves nothing. */
  if(!window.hohSupabaseClient){
    window.hohSupabaseClient = {
      __hhpShim: true,
      rpc: function(fn, args){
        return send(CFG.supabaseUrl + '/rest/v1/rpc/' + fn, { body: args || {} }).then(function(r){
          if(r.network) return { data: null, error: { message: 'network' } };
          if(r.status >= 200 && r.status < 300) return { data: r.json, error: null };
          var e = (r.json && typeof r.json === 'object') ? r.json : { message: 'HTTP ' + r.status };
          return { data: null, error: e };
        });
      }
    };
  }

  /* ---------------------------------------------------------------- R795 doors */
  function acct(extra){ var t = token(); if(!t) return null; var a = { p_email: t.email, p_pin: t.pin }; Object.keys(extra || {}).forEach(function(k){ a[k] = extra[k]; }); return a; }
  function needSignIn(){ return Promise.resolve({ ok: false, reason: 'sign_in_required' }); }
  function ownerDoor(fn, extra){ var a = acct(extra); return a ? door(fn, a) : needSignIn(); }
  /* The page door's first answer may already be in flight from the section's inline script. */
  function page(ref){
    var b = window.__hhpBoot;
    if(b && b.page && b.ref === ref && !b.used){
      b.used = true;
      return b.page.then(function(res){
        if(!res || !res.status) return { ok: false, network: true, reason: 'network' };
        return interpretDoor(interpretRaw({ status: res.status, json: res.body }, 'hoh_hero_page'));
      });
    }
    return door('hoh_hero_page', { p_ref: ref });
  }
  var DOORS = {
    page: page,
    refresh: function(id){ return door('hoh_hero_page_refresh', { p_hero_id: id }); },
    owner: function(id){ return ownerDoor('hoh_hero_owner', { p_hero_id: id }); },
    answerSave: function(id, qid, text){ return ownerDoor('hoh_hero_answer_save', { p_hero_id: id, p_question_id: qid, p_text: text }); },
    blueprintSave: function(id, fields, lists){ var x = { p_hero_id: id, p_fields: fields || {} }; if(lists) x.p_lists = lists; return ownerDoor('hoh_hero_blueprint_save', x); },
    refsSet: function(id, refs){ return ownerDoor('hoh_hero_refs_set', { p_hero_id: id, p_refs: refs }); },
    questCandidates: function(id){ return ownerDoor('hoh_hero_quest_candidates', { p_hero_id: id }); },
    questImport: function(id, lead, mode){ return ownerDoor('hoh_hero_quest_import', { p_hero_id: id, p_lead_id: String(lead), p_mode: mode || 'fill' }); },
    notes: function(id){ return ownerDoor('hoh_hero_notes', { p_hero_id: id }); },
    noteSave: function(id, note){ return ownerDoor('hoh_hero_note_save', { p_hero_id: id, p_note: note }); },
    noteDelete: function(id, noteId){ return ownerDoor('hoh_hero_note_delete', { p_hero_id: id, p_note_id: noteId }); },
    /* HALL-OWN-TITLE: the owner's own title and phrase (a blank title takes it away) */
    titleOwn: function(id, title, subtext){ return ownerDoor('hoh_hero_title_own', { p_hero_id: id, p_title: title, p_subtext: subtext }); }
  };

  /* ---------------------------------------------------------------- the catalog */
  /* The server owns the catalog (ids, pillars, points, ask, help, ideas). The
     page styles it and keeps the last good copy on this device, so a slow
     catalog answer never blocks a page that has been seen before. Field names
     are read through a few aliases because the SQL is being built in parallel. */
  var CAT_KEY = 'hhp:catalog';
  var SEC_DEFAULT = {
    id: { name: 'Who they are', short: 'Who', cap: 15, core: true },
    dr: { name: 'What drives them', short: 'Drives', cap: 25, core: true },
    pe: { name: 'People and places', short: 'People', cap: 25, core: true },
    ho: { name: 'Hooks for the DM', short: 'Hooks', cap: 15, core: true },
    rp: { name: 'At the table', short: 'Table', cap: 10, core: true },
    /* HEROPOLISH (Jan, 2026-09-25: "this should be Character Blueprint not just blueprint"). The
       six equal section chips on a phone keep the one word (the full name does not fit a chip). */
    bp: { name: 'Character Blueprint', short: 'Blueprint', cap: 10, core: false }
  };
  var SEC_ORDER = ['id', 'dr', 'pe', 'ho', 'rp', 'bp'];
  var TIER_DEFAULT = [
    { k: 'common', name: 'Common', min: 0 },
    { k: 'uncommon', name: 'Uncommon', min: 25, breadth: 2 },
    { k: 'rare', name: 'Rare', min: 45, breadth: 4 },
    { k: 'epic', name: 'Epic', min: 65, core: true },
    { k: 'legendary', name: 'Legendary', min: 85, core: true, bp: true }
  ];
  var VIBES = ['Battle Ready', 'Quiet Power', 'Brooding', 'Cocky Grin', 'Noble', 'Wild', 'Mysterious', 'Warm'];
  var EXPRS = ['Determined stare', 'Slight smirk', 'Warm smile', 'Cold intensity', 'Thoughtful gaze', 'Fierce snarl', 'Playful grin', 'Weary but unbroken', 'Serene calm', 'Barely contained rage', 'Mischievous eyes', 'Haunted look'];
  var PERSONAS = ['Never breaks first', 'Laughs at the wrong moment', 'Always pays the bar tab', "Can't stop helping strangers", 'Has names to find', 'Running from something', 'Came to prove something', 'Already paid the price'];
  /* ql = the Quest's own label (printed on the export so the portal reader
     maps it back), pl = the page label, g = where the page groups it */
  var BP_DEFAULT = {
    mustHave: { ql: 'Must Capture', pl: 'Must capture', g: 'guide', req: 1, ord: 1, ask: 'What must an artist get right about {N}?', help: 'The two or three things that make a portrait unmistakably {N}.' },
    vibe: { ql: 'Portrait Vibe', pl: 'Vibe', g: 'dir', req: 1, ord: 2, kind: 'pick', picks: VIBES, ask: "What's the vibe of {N}'s portrait?", help: 'Pick the one closest.' },
    expression: { ql: 'Expression', pl: 'Expression', g: 'dir', req: 1, ord: 3, kind: 'pick', picks: EXPRS, ask: "What expression is on {N}'s face?", help: 'Pick the one closest.' },
    hairDesc: { ql: 'Hair', pl: 'Hair', g: 'face', req: 1, ord: 4, picks: ['Long and dark', 'Short crop', 'Silver white', 'Copper red'], ask: "What's {N}'s hair like?", help: "Colour, length, how it's worn." },
    skinDesc: { ql: 'Skin & Race Features', pl: 'Skin and race features', g: 'face', req: 1, ord: 5, picks: ['Warm brown', 'Pale', 'Sun tanned', 'Ashen grey'], ask: "What about {N}'s skin, and anything their race adds?", help: 'Horns, scales, ears, markings.' },
    armor: { ql: 'Armor & Outfit', pl: 'Armor and outfit', g: 'gear', req: 1, ord: 6, picks: ['Plate armor', 'Leather armor', 'Flowing robes', 'Common clothes'], ask: 'What is {N} wearing?', help: "What they'd be painted in." },
    weapon: { ql: 'Weapon & Focus', pl: 'Weapon and focus', g: 'gear', req: 1, ord: 7, picks: ['Sword and shield', 'Twin daggers', 'Bow and quiver', 'Staff or focus'], ask: 'What does {N} fight or cast with?', help: 'A weapon, a focus, an instrument.' },
    personality: { ql: 'Personality', pl: 'Personality', g: 'story', req: 1, ord: 8, picks: PERSONAS, ask: 'Which of these sounds most like {N}?', help: 'Pick one, or write your own.' },
    definingMoment: { ql: 'Defining Moment', pl: 'Defining moment', g: 'story', req: 1, ord: 9, max: 4000, ask: 'What moment made {N} who they are?', help: 'The scene an artist could paint behind them.' },
    pleaseAvoid: { ql: 'Please Avoid', pl: 'Please avoid', g: 'guide', ord: 10, ask: "Anything you don't want in {N}'s portrait?", help: 'Colours, moods, details to leave out.' },
    genderPronouns: { ql: 'Gender & Pronouns', pl: 'Gender and pronouns', g: 'id', ord: 11 },
    facialFeatures: { ql: 'Facial Features', pl: 'Facial features', g: 'face', ord: 12 },
    eyeDesc: { ql: 'Eyes', pl: 'Eyes', g: 'face', ord: 13 },
    distinguishing: { ql: 'Scars, Tattoos & Markings', pl: 'Scars, tattoos and markings', g: 'body', ord: 14 },
    buildAge: { ql: 'Build & Age', pl: 'Build and age', g: 'body', ord: 15 },
    appendages: { ql: 'Horns, Tail, Wings, etc.', pl: 'Horns, tail or wings', g: 'body', ord: 16 },
    accessories: { ql: 'Accessories & Jewelry', pl: 'Accessories and jewelry', g: 'gear', ord: 17 },
    signatureItem: { ql: 'Signature Item', pl: 'Signature item', g: 'gear', ord: 18 },
    pets: { ql: 'Pets & Familiars', pl: 'Pets and familiars', g: 'gear', ord: 19 },
    colors: { ql: 'Color Palette', pl: 'Color palette', g: 'gear', ord: 20 },
    pose: { ql: 'Pose', pl: 'Pose', g: 'dir', ord: 21 },
    bgPreference: { ql: 'Portrait Background', pl: 'Background', g: 'dir', ord: 22 },
    campaign: { ql: 'Campaign', pl: 'Campaign', g: 'story', ord: 23 },
    fear: { ql: 'Fear', pl: 'Fear', g: 'story', ord: 24 }
  };
  function pick(o){ for(var i = 1; i < arguments.length; i++){ var v = o[arguments[i]]; if(v !== undefined && v !== null && v !== '') return v; } return undefined; }
  function arr(v){ return Array.isArray(v) ? v.filter(function(x){ return has(x); }).map(String) : (has(v) ? [String(v)] : []); }
  function normCatalog(raw){
    raw = raw || {};
    var secs = (Array.isArray(raw.sections) ? raw.sections : []).map(function(s){
      var k = String(pick(s, 'k', 'key', 'id', 'section') || ''); var d = SEC_DEFAULT[k] || {};
      return { k: k, name: pick(s, 'name', 'label', 'title') || d.name || k, short: pick(s, 'short', 'short_name', 'chip') || d.short || k, cap: Number(pick(s, 'cap', 'max', 'points')) || d.cap || 10, core: pick(s, 'core') != null ? !!pick(s, 'core') : !!d.core };
    }).filter(function(s){ return s.k; });
    if(!secs.length) secs = SEC_ORDER.map(function(k){ var d = SEC_DEFAULT[k]; return { k: k, name: d.name, short: d.short, cap: d.cap, core: d.core }; });
    secs.sort(function(a, b){ var ia = SEC_ORDER.indexOf(a.k), ib = SEC_ORDER.indexOf(b.k); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); });
    var qs = (Array.isArray(raw.questions) ? raw.questions : []).map(function(q, i){
      return {
        id: String(pick(q, 'id', 'key', 'question_id') || ''), p: String(pick(q, 'p', 'section', 'pillar', 'sec') || ''),
        pts: Number(pick(q, 'pts', 'points', 'score')) || 0, first: Number(pick(q, 'first', 'first_order', 'first_ten')) || 0,
        eff: String(pick(q, 'eff', 'effort') || 'q').charAt(0) === 'd' ? 'd' : 'q',
        label: pick(q, 'label', 'public_label') || '', ask: pick(q, 'ask', 'question', 'prompt') || '', help: pick(q, 'help', 'hint') || '',
        ideas: arr(pick(q, 'ideas', 'idea', 'examples')), order: Number(pick(q, 'ord', 'order', 'position')) || (i + 1)
      };
    }).filter(function(q){ return q.id && q.p && q.ask; });
    qs.sort(function(a, b){ return a.order - b.order; });
    qs.forEach(function(q, i){ q.order = i; });
    var bp = (Array.isArray(raw.blueprint) ? raw.blueprint : []).map(function(f, i){
      var k = String(pick(f, 'k', 'key', 'field') || ''); var d = BP_DEFAULT[k] || {};
      var picks = arr(pick(f, 'picks', 'options', 'choices'));
      var kind = String(pick(f, 'kind', 'type') || d.kind || 'text') === 'pick' ? 'pick' : 'text';
      return {
        k: k, pl: pick(f, 'pl', 'page_label', 'label') || d.pl || k, ql: pick(f, 'ql', 'quest_label', 'pdf_label') || d.ql || pick(f, 'label') || k,
        kind: kind, picks: picks.length ? picks : (d.picks || []), max: Number(pick(f, 'max_len', 'max', 'maxlength')) || d.max || 500,
        ord: Number(pick(f, 'ord', 'order')) || d.ord || (i + 1), req: pick(f, 'required', 'req') != null ? !!pick(f, 'required', 'req') : !!d.req,
        g: d.g || 'story', ask: pick(f, 'ask', 'question') || d.ask || ('Add ' + String(d.pl || k).toLowerCase()), help: pick(f, 'help', 'hint') || d.help || ''
      };
    }).filter(function(f){ return f.k; });
    if(!bp.length) bp = Object.keys(BP_DEFAULT).map(function(k){ var d = BP_DEFAULT[k]; return { k: k, pl: d.pl, ql: d.ql, kind: d.kind || 'text', picks: d.picks || [], max: d.max || 500, ord: d.ord, req: !!d.req, g: d.g, ask: d.ask || ('Add ' + d.pl.toLowerCase()), help: d.help || '' }; });
    bp.sort(function(a, b){ return a.ord - b.ord; });
    var tiers = (Array.isArray(raw.tiers) ? raw.tiers : []).map(function(t){
      var k = String(pick(t, 'k', 'key', 'tier', 'id') || ''); var d = TIER_DEFAULT.filter(function(x){ return x.k === k; })[0] || {};
      var breadth = Number(pick(t, 'breadth', 'sections', 'with_info', 'min_sections'));
      return { k: k, name: pick(t, 'name', 'label') || d.name || k, min: Number(pick(t, 'min', 'points', 'at', 'min_points')) || d.min || 0,
        breadth: breadth || d.breadth || 0, core: pick(t, 'core', 'core_all') != null ? !!pick(t, 'core', 'core_all') : !!d.core,
        bp: pick(t, 'bp', 'blueprint', 'needs_blueprint', 'bp_complete') != null ? !!pick(t, 'bp', 'blueprint', 'needs_blueprint', 'bp_complete') : !!d.bp };
    }).filter(function(t){ return t.k && t.k !== 'mythic'; });
    if(!tiers.length) tiers = TIER_DEFAULT.map(function(t){ return Object.assign({}, t); });
    tiers.sort(function(a, b){ return a.min - b.min; });
    var cat = {
      version: String(raw.version || ''), questions: qs, sections: secs, tiers: tiers, blueprint: bp,
      endowed: Number(raw.endowed) || 5, limits: raw.limits || {}, raw: raw
    };
    cat.q = {}; qs.forEach(function(q){ cat.q[q.id] = q; });
    cat.sec = {}; secs.forEach(function(s){ cat.sec[s.k] = s; });
    cat.f = {}; bp.forEach(function(f){ cat.f[f.k] = f; });
    cat.first = qs.filter(function(q){ return q.first; }).sort(function(a, b){ return a.first - b.first; });
    cat.bpReq = bp.filter(function(f){ return f.req; });
    cat.answerMax = Number(pick(cat.limits, 'answer_max', 'answer', 'answer_len')) || 1200;
    return cat;
  }
  var catPromise = null;
  function catalog(force){
    if(catPromise && !force) return catPromise;
    var cached = store.get(CAT_KEY, null);
    /* HEROSPEED (2026-10-14): a first visit's catalog request may already be in flight from the section's inline
       script (started beside the page door), so the first render no longer waits for a second round trip. */
    var b = window.__hhpBoot, early = (!force && b && b.cat && !b.catUsed) ? b.cat : null;
    if(early) b.catUsed = true;
    var ask = early ? early.then(function(res){
      if(!res || !res.status) return { ok: false, network: true, reason: 'network' };
      return interpretDoor(interpretRaw({ status: res.status, json: res.body }, 'hoh_hero_catalog'));
    }) : door('hoh_hero_catalog', {});
    var fresh = ask.then(function(r){
      if(r.ok && r.data && Array.isArray(r.data.questions) && r.data.questions.length){
        store.set(CAT_KEY, { at: Date.now(), raw: r.data });
        return { ok: true, cat: normCatalog(r.data) };
      }
      if(cached && cached.raw) return { ok: true, cat: normCatalog(cached.raw), stale: true, reason: r.reason, missing: !!r.missing };
      return { ok: false, reason: r.reason, missing: !!r.missing, network: !!r.network };
    });
    if(cached && cached.raw && !force){
      catPromise = Promise.resolve({ ok: true, cat: normCatalog(cached.raw), cached: true, fresh: fresh });
    } else {
      catPromise = fresh;
    }
    catPromise.then(function(r){ if(!r || !r.ok) catPromise = null; });
    return catPromise;
  }

  /* ---------------------------------------------------------------- payloads */
  var TIER_KEYS = ['common', 'uncommon', 'rare', 'epic', 'legendary', 'mythic'];
  function tierKey(v){ v = String(v || '').toLowerCase(); return TIER_KEYS.indexOf(v) >= 0 ? v : 'common'; }
  /* the Hall's legacy-hearts ladder (hohGetRarity): the floor for every hero before R795 */
  function legacyTier(hearts){ var n = hearts | 0; return n >= 1200 ? 'mythic' : n >= 1000 ? 'legendary' : n >= 500 ? 'epic' : n >= 200 ? 'rare' : n >= 50 ? 'uncommon' : 'common'; }
  /* R805 (Jan, 2026-09-25): "ff portraits basically just get +1 tier up, so if its legendary it can
     go to mythic, versus normal portraits stop at legendary ... it doesnt just start in mythic, its
     based off of how much is filled out". The server's tier is shown as it comes, never forced: its
     view gives a FramedFantasy portrait the tier its page has earned plus one (Uncommon with nothing
     filled in, Mythic only once everything Legendary needs is in) and says so with ff. Before R805
     the server showed every FramedFantasy portrait as Mythic and sent no ff; the page then draws the
     plain ladder under that Mythic, as it always did. mythic means "at the top": the Mythic tier,
     however it came (earned by a FramedFantasy portrait, or 1,200 legacy hearts on any hero). */
  var TIER_NAMES = { common: 'Common', uncommon: 'Uncommon', rare: 'Rare', epic: 'Epic', legendary: 'Legendary', mythic: 'Mythic' };
  /* the ladder this hero climbs: the catalog's five steps, their points, sections and Character
     Blueprint rules unchanged, one tier higher for a FramedFantasy portrait (Uncommon to Mythic).
     The copy shares everything else with the catalog (questions, sections, the blueprint fields). */
  function heroCat(cat, ff){
    if(!cat || !ff) return cat;
    return Object.assign({}, cat, { ff: true, tiers: cat.tiers.map(function(T){
      var k = TIER_KEYS[Math.min(TIER_KEYS.length - 1, TIER_KEYS.indexOf(T.k) + 1)];
      return Object.assign({}, T, { k: k, name: TIER_NAMES[k], fill: T.k });
    }) });
  }
  /* the tier a Hall tile shows (hohHallTier in hoh-section-core.js keeps the same rule): the stored
     tier, which never falls, and a FramedFantasy portrait is never below Uncommon */
  /* MYTHICFF (Jan, 2026-09-30): "mythic should only be achievable by an FF portrait". Any other
     hero tops out at Legendary, whatever its stored row or legacy hearts say. */
  function capTier(t, ff){ return (!ff && t === 'mythic') ? 'legendary' : t; }
  function hallTier(row){
    var e = row && row.hero_rarity; if(Array.isArray(e)) e = e[0];
    var ff = !!(row && row.is_ff_portrait);
    var t = capTier(tierKey(e && e.tier), ff);
    return (ff && t === 'common') ? 'uncommon' : t;
  }
  function normRarity(r, hero){
    r = r || {};
    var s = r.sections || {};
    var sections = {}; SEC_ORDER.forEach(function(k){ sections[k] = Math.max(0, Number(s[k]) || 0); });
    var ff = typeof r.ff === 'boolean' ? r.ff : !!(hero && hero.is_ff_portrait);
    var tier = capTier(tierKey(r.tier), ff);
    return {
      tier: tier, stored: capTier(tierKey(r.stored || r.tier), ff), computed: tierKey(r.computed), legacy: capTier(tierKey(r.legacy), ff),
      mythic: tier === 'mythic', ff: r.ff === true, r805: typeof r.ff === 'boolean', points: Math.max(0, Math.min(100, Number(r.points) || 0)), sections: sections,
      with_info: Number(r.with_info) || 0, core_all: !!r.core_all, bp_filled: Math.max(0, Number(r.bp_filled) || 0), bp_complete: !!r.bp_complete,
      rose: r.rose ? tierKey(r.rose) : null
    };
  }
  function normBlueprint(b){
    if(!b || typeof b !== 'object') return null;
    var lists = b.lists || {};
    return {
      fields: (b.fields && typeof b.fields === 'object') ? b.fields : {},
      field_src: b.field_src || {},
      lists: {
        people: Array.isArray(lists.people) ? lists.people.slice(0, 12) : [],
        places: Array.isArray(lists.places) ? lists.places.slice(0, 12) : [],
        swatches: Array.isArray(lists.swatches) ? lists.swatches.slice(0, 5) : []
      },
      refs: Array.isArray(b.refs) ? b.refs : [],
      filled: Number(b.filled) || 0, complete: !!b.complete, completed_at: b.completed_at || null,
      from_quest: !!b.from_quest, updated_at: b.updated_at || null
    };
  }
  function normTitle(t){
    if(!t || typeof t !== 'object' || !has(t.title)) return null;
    return { id: t.id || null, title: String(t.title), subtext: String(t.subtext || ''), tier: t.tier || '', source: t.source || '', alternates: arr(t.alternates), created_at: t.created_at || null };
  }
  function normPage(d){
    var hero = d.hero || {};
    var answers = {}, list = [];
    (Array.isArray(d.answers) ? d.answers : []).forEach(function(a){
      if(!a) return; var id = String(pick(a, 'id', 'question_id') || ''); var text = String(pick(a, 'text', 'answer') || '');
      if(!id || !has(text)) return; answers[id] = { text: text, updated_at: a.updated_at || null }; list.push(id);
    });
    return {
      hero: hero, rarity: normRarity(d.rarity, hero), answers: answers, answerIds: list,
      blueprint: normBlueprint(d.blueprint), title: normTitle(d.title), title_unlocked: !!d.title_unlocked,
      fallback: !!d.__fallback
    };
  }
  function normOwner(d){
    var o = (d && d.owner && typeof d.owner === 'object') ? d.owner : (d || {});
    var rolls = o.title_rolls || {};
    return {
      visible: o.visible !== false, review: String(o.review || 'live'), refs: Array.isArray(o.refs) ? o.refs : [],
      imports: Array.isArray(o.imports) ? o.imports : [], prefill: (o.prefill && typeof o.prefill === 'object') ? o.prefill : {},
      /* HEROUX (Jan, 2026-09-24): one new title a day per hero. The server's rolls.left and
         next_at decide; this default only covers an answer without them */
      title_rolls: { left: rolls.left == null ? 1 : Math.max(0, rolls.left | 0), used_today: rolls.used_today | 0, next_at: rolls.next_at || null, pending: !!rolls.pending },
      notes_count: o.notes_count | 0,
      title_own: normTitleOwn(o.title_own)
    };
  }
  /* HALL-OWN-TITLE (sql/HALL-OWN-TITLE-UPDATE.sql): the owner view carries title_own only once the server has the
     owner's title door, so its absence (or anything malformed) is null and the page offers nothing (fail closed) */
  function normTitleOwn(x){
    if(!x || typeof x !== 'object' || !(Number(x.max_title) > 0)) return null;
    return { max_title: Math.min(80, Number(x.max_title) | 0), max_subtext: Math.min(240, Number(x.max_subtext) | 0), per_day: Number(x.per_day) | 0,
      left_today: x.left_today == null ? 1 : Math.max(0, x.left_today | 0), next_at: x.next_at || null, current: !!x.current };
  }
  /* the door's own rules, so the page can answer as the player types (the server runs the same and its answer wins):
     one line (every run of spaces and line breaks is one space), trimmed, a title of 2 to max_title characters and
     a phrase of up to max_subtext, no < or > and no control character, and the Hall's check for public text (the
     judge below, where a short text is fine) */
  function oneLine(t){ return String(t == null ? '' : t).replace(/[\s\u00a0\ufeff]+/g, ' ').trim(); }
  function chars(t){ return Array.from(String(t || '')).length; }
  function judgeOwnTitle(field, raw, heroName, lim){
    var t = oneLine(raw), max = field === 'title' ? ((lim && lim.max_title) || 40) : ((lim && lim.max_subtext) || 90);
    if(field === 'title' && chars(t) < 2) return { ok: false, why: t ? 'too_short' : 'empty' };
    if(!t) return { ok: true };
    if(chars(t) > max) return { ok: false, why: 'too_long', max: max };
    if(/[<>\u0000-\u001f\u007f-\u009f]/.test(t)) return { ok: false, why: 'markup' };
    var j = judge(t, [], [], heroName);
    return j.ok || j.why === 'short' ? { ok: true } : { ok: false, why: j.why };
  }

  /* ---------------------------------------------------------------- the title route (Worker) */
  function titleRoll(heroId, reroll, requestId){
    var t = token(); if(!t) return Promise.resolve({ ok: false, code: 'sign_in_required' });
    return send(CFG.workerUrl + '/hall-tools/title', { headers: { 'Content-Type': 'application/json' }, timeout: 45000,
      body: { email: t.email, pin: t.pin, hero_id: heroId, request_id: requestId || uuid(), reroll: !!reroll } }).then(function(r){
      if(r.network) return { ok: false, code: 'network', network: true };
      var j = (r.json && typeof r.json === 'object') ? r.json : {};
      if(r.status >= 200 && r.status < 300 && j.success) return { ok: true, data: j, title: normTitle(j.title), rolls: j.rolls || null, cached: !!j.cached };
      var code = j.code ? String(j.code) : ((r.status === 404 || r.status === 405) ? 'unavailable' : 'http_' + r.status);
      return { ok: false, code: code, status: r.status, error: String(j.error || ''), next_at: j.next_at || (j.rolls && j.rolls.next_at) || null };
    });
  }

  /* ---------------------------------------------------------------- R795b · the card's words (Worker /card-text) */
  /* The Hall's and the Worker's own "missing" rule (hoh-shop.js needsCardText,
     cardTextNeedsWriting in the Worker): never the owner's own words; otherwise
     no line, the neutral line, or a line that only repeats the story's start. */
  function cardNeedsText(meta, story){
    meta = (meta && typeof meta === 'object') ? meta : {};
    if(meta.edited === true) return false;
    function norm(v){ return String(v || '').replace(/\s+/g, ' ').replace(/[\u2018\u2019]/g, "'").trim().toLowerCase(); }
    var l = norm(meta.legend);
    if(!l || l === 'a brave hero of the hall.') return true;
    var pre = l.replace(/[\u2026.]+$/, '').slice(0, 80), s = norm(story);
    return pre.length >= 24 && s.length >= 24 && s.indexOf(pre) === 0;
  }
  /* R795b: the answers write the hero's story (R795bB), and a card the Worker
     wrote from the basics alone gives up its words once the hero has ten
     answers (the server decides, on an answer save). This
     asks the Worker's existing /card-text route to write the card again, at
     most once per hero per page load. The route writes only a card that needs
     words and never an owner's own, so a call it does not need costs nothing.
     Silent: any failure waits for the next visit. */
  var cardAsked = {};
  function cardTextAsk(heroId){
    if(!heroId || !UUID_RE.test(String(heroId)) || cardAsked[heroId] || !CFG.workerUrl) return Promise.resolve(null);
    cardAsked[heroId] = 1;
    return send(CFG.workerUrl + '/card-text', { headers: { 'Content-Type': 'application/json' }, timeout: 45000, body: { character_id: String(heroId) } }).then(function(r){
      var j = (r && r.json && typeof r.json === 'object') ? r.json : null;
      return (r && r.status >= 200 && r.status < 300 && j && j.ok === true && j.meta && typeof j.meta === 'object') ? j.meta : null;
    }, function(){ return null; });
  }

  /* ---------------------------------------------------------------- before R795 is installed */
  var SAFE_COLS = 'id,slug,name,race,character_class,dnd_level,level,campaign,player_name,story,image_url,image_thumb_url,image_url_2,image_thumb_url_2,image_offset_x,image_offset_y,image_offset_x_2,image_offset_y_2,image_zoom,image_zoom_2,is_animated,is_animated_2,video_url,is_ff_portrait,artwork_cover,card_meta,stats_block,quest_meta,npc_card,npc_current_goal,npc_hidden_weakness,npc_habit,npc_catchphrase,npc_secret,npc_enemy,share_card_url,blueprint_pdf_url,hearts,tickets,created_at,last_edited_at';
  function heroQuery(ref, cols, visibleOnly){
    var q = 'characters?select=' + cols + (UUID_RE.test(ref) ? '&id=eq.' + encodeURIComponent(ref) : '&slug=eq.' + encodeURIComponent(String(ref).toLowerCase()));
    if(visibleOnly) q += '&approved=eq.true&is_hidden=not.is.true';
    return q + '&limit=1';
  }
  /* the public row, shaped like the page door's payload */
  function heroFallback(ref){
    return get(heroQuery(ref, SAFE_COLS, true)).then(function(r){
      if(r.network) return { ok: false, network: true, reason: 'network' };
      if(r.status < 200 || r.status >= 300) return { ok: false, reason: 'http_' + r.status, network: r.status >= 500 };
      var row = Array.isArray(r.json) ? r.json[0] : null;
      if(!row) return { ok: false, reason: 'no_hero' };
      row.legacy_hearts = row.hearts | 0; delete row.hearts;
      row.from_quest = !!(row.quest_meta && typeof row.quest_meta === 'object' && Object.keys(row.quest_meta).length);
      var ff = !!row.is_ff_portrait, cm = row.card_meta || {};
      return { ok: true, data: {
        ok: true, __fallback: true, hero: row,
        /* R805: the legacy-hearts floor; a FramedFantasy portrait is at least Uncommon */
        rarity: { tier: ff && legacyTier(row.legacy_hearts) === 'common' ? 'uncommon' : legacyTier(row.legacy_hearts), stored: legacyTier(row.legacy_hearts), ff: ff, points: 0, sections: {} },
        answers: [], blueprint: null, title: has(cm.epithet) ? { title: cm.epithet, subtext: '', source: 'epithet' } : null, title_unlocked: false
      } };
    });
  }
  /* A hidden or pending hero answers no_hero to visitors. Its owner still
     reaches it through the owner door, which wants the id. */
  function resolveId(ref){
    if(UUID_RE.test(ref)) return Promise.resolve(ref);
    return get(heroQuery(ref, 'id', false)).then(function(r){ var row = (r && Array.isArray(r.json)) ? r.json[0] : null; return row && row.id ? String(row.id) : null; });
  }
  var MORE_COLS = 'id,slug,name,race,character_class,image_thumb_url,image_url,image_offset_x,image_offset_y,image_zoom,is_ff_portrait';
  function moreHeroes(hero){
    var base = 'characters?select=' + MORE_COLS + '{EMBED}&approved=eq.true&is_hidden=not.is.true&image_url=not.is.null&id=neq.' + encodeURIComponent(hero.id) + '&order=created_at.desc&limit=30';
    var filter = hero.is_ff_portrait ? '&is_ff_portrait=eq.true' : (has(hero.character_class) ? '&character_class=eq.' + encodeURIComponent(hero.character_class) : '');
    function run(embed){ return get(base.replace('{EMBED}', embed ? ',hero_rarity(tier)' : '') + filter); }
    return run(true).then(function(r){ return (r.status >= 200 && r.status < 300) ? r : run(false); }).then(function(r){
      if(r.status < 200 || r.status >= 300 || !Array.isArray(r.json)) return { ok: false };
      var rows = r.json.filter(function(x){ return x && x.id && (x.image_thumb_url || x.image_url); });
      var seed = hash(String(hero.id) + new Date().toISOString().slice(0, 10));
      rows.sort(function(a, b){ return hash(seed + a.id) - hash(seed + b.id); });
      /* a neutral label for the portrait heroes: nothing on the page explains Mythic */
      return { ok: true, heroes: rows.slice(0, 6), label: hero.is_ff_portrait ? 'More heroes in the Hall' : (has(hero.character_class) ? 'Other ' + hero.character_class + 's in the Hall' : 'More heroes') };
    });
  }

  /* ---------------------------------------------------------------- artwork (today's save path, hoh-tools.js) */
  function toolsCall(fn, args){
    return call(fn, args).then(function(r){
      if(!r.ok) return { ok: false, reason: r.reason, missing: !!r.missing, network: !!r.network, message: r.message || '' };
      return { ok: true, data: r.data };
    });
  }
  function artworks(heroId){ return toolsCall('hoh_tools_public', { p_id: heroId }).then(function(r){ return r.ok ? { ok: true, artworks: (r.data && Array.isArray(r.data.artworks)) ? r.data.artworks : [], data: r.data } : r; }); }
  function removedArt(heroId){ var t = token(); if(!t) return needSignIn(); return toolsCall('hoh_tools_removed_art', { p_email: t.email, p_pin: t.pin, p_hero: heroId }).then(function(r){ return r.ok ? { ok: true, removed: Array.isArray(r.data) ? r.data : [] } : r; }); }
  function artAction(action, payload){ var t = token(); if(!t) return needSignIn(); return toolsCall('hoh_tools_account', { p_email: t.email, p_pin: t.pin, p_action: action, p_payload: payload || {} }); }
  function workerJson(path, body){
    return send(CFG.workerUrl + '/hall-tools' + path, { headers: { 'Content-Type': 'application/json' }, body: body, timeout: 30000 }).then(function(r){
      if(r.network) return { ok: false, network: true, message: '' };
      var j = (r.json && typeof r.json === 'object') ? r.json : {};
      return (r.status >= 200 && r.status < 300) ? { ok: true, data: j } : { ok: false, status: r.status, message: String(j.error || '') };
    });
  }
  function uploadArt(heroId, files, meta){
    var t = token(); if(!t) return needSignIn();
    var form = new FormData();
    form.set('metadata', JSON.stringify(Object.assign({ hero_id: heroId, email: t.email, pin: t.pin }, meta || {})));
    (files || []).forEach(function(f){ form.set(f.name, f.blob, f.name + '.webp'); });
    return send(CFG.workerUrl + '/hall-tools/artwork', { headers: {}, body: form, timeout: 60000 }).then(function(r){
      if(r.network) return { ok: false, network: true, message: '' };
      var j = (r.json && typeof r.json === 'object') ? r.json : {};
      return (r.status >= 200 && r.status < 300) ? { ok: true, data: j } : { ok: false, status: r.status, message: String(j.error || '') };
    });
  }
  function purgeArt(heroId, artId){ var t = token(); if(!t) return needSignIn(); return workerJson('/remove-artwork', { hero_id: heroId, id: artId, email: t.email, pin: t.pin }); }
  /* The Hall's zoom-aware reframe door (R729): X, Y and zoom together, owner or admin. */
  function reframe(heroId, slot, x, y, zoom, hero){
    var t = token(); if(!t) return needSignIn();
    var s = slot === 'secondary' ? 'secondary' : 'primary';
    var px = Math.round(clamp(x, 0, 100, 50)), py = Math.round(clamp(y, 0, 100, 50)), pz = Math.round(clamp(zoom, 100, 200, 100));
    return call('set_character_image_reframe', { p_email: t.email, p_pin: t.pin, p_id: heroId, p_slot: s, p_x: px, p_y: py, p_zoom: pz }).then(function(r){
      if(!r.ok) return { ok: false, reason: r.reason, missing: !!r.missing, network: !!r.network };
      var d = Array.isArray(r.data) ? r.data[0] : r.data;
      if(!d || d.ok !== true) return { ok: false, reason: String((d && (d.error || d.reason)) || 'refused') };
      /* SAVESTICK (Jan, 2026-10-14): the server has it now, so the hero takes the
         saved values and this device's own keys for the slot go. Writing them
         here (as before) made this device override the server forever, hiding
         any later fix. */
      if(hero && typeof hero === 'object'){ var sfx = s === 'secondary' ? '_2' : ''; hero['image_offset_x' + sfx] = px; hero['image_offset_y' + sfx] = py; hero['image_zoom' + sfx] = pz; }
      try {
        var map = store.get('hoh-img-offsets-v1', {}) || {}, k = heroId + ':' + s, hit = false;
        [k, k + ':x', k + ':zoom'].forEach(function(key){ if(Object.prototype.hasOwnProperty.call(map, key)){ delete map[key]; hit = true; } });
        if(hit) store.set('hoh-img-offsets-v1', map);
      } catch(_){}
      return { ok: true };
    });
  }
  /* The framing the Hall would draw on this device: its local map first, then the row. */
  function framing(hero, slot){
    var s = slot === 'secondary' ? 'secondary' : 'primary', id = String(hero && hero.id || '');
    var map = store.get('hoh-img-offsets-v1', {}) || {};
    function local(k, lo, hi){ var v = map[id + ':' + s + k]; return (typeof v === 'number' && v >= lo && v <= hi) ? v : null; }
    var sx = s === 'secondary' ? hero.image_offset_x_2 : hero.image_offset_x, sy = s === 'secondary' ? hero.image_offset_y_2 : hero.image_offset_y, sz = s === 'secondary' ? hero.image_zoom_2 : hero.image_zoom;
    /* HEROFRAME (Jan, 2026-10-14: "fix it all so its inheriting the correct reframe from the main hall"): a hero
       with no saved framing has null columns, and clamp's Number(null) is 0, so every such hero was pinned to its
       top-left corner here while the Hall centres it (hohGetImageOffsetX trusts only a real number, else 50). An
       empty value now means the default, exactly as in the Hall. */
    function saved(v, lo, hi, d){ return (v === null || v === undefined || v === '') ? d : clamp(v, lo, hi, d); }
    var x = local(':x', 0, 100); if(x == null) x = saved(sx, 0, 100, 50);
    var y = local('', 0, 100); if(y == null) y = saved(sy, 0, 100, 50);
    var z = local(':zoom', 100, 200); if(z == null) z = saved(sz, 100, 200, 100);
    return { x: x, y: y, zoom: z };
  }
  function imgStyle(f){ var pos = Math.round(f.x) + '% ' + Math.round(f.y) + '%'; return 'object-position:' + pos + ';transform-origin:' + pos + ';scale:' + (Math.round(f.zoom) / 100) + ';'; }
  /* hoh-tools.js crop and prepareImages, the same three sizes the Worker expects */
  function crop(bitmap, canvas, x, y, zoom){ var side = Math.min(bitmap.width, bitmap.height) / zoom, sx = (bitmap.width - side) * x / 100, sy = (bitmap.height - side) * y / 100; var ctx = canvas.getContext('2d'); ctx.clearRect(0, 0, canvas.width, canvas.height); ctx.drawImage(bitmap, sx, sy, side, side, 0, 0, canvas.width, canvas.height); }
  function prepareImages(bitmap, x, y, zoom){
    var canvases = [['master', 2048], ['card', 768], ['thumb', 320]].map(function(p){
      var c = document.createElement('canvas');
      if(p[0] === 'master'){ var sc = Math.min(1, p[1] / Math.max(bitmap.width, bitmap.height)); c.width = Math.max(1, Math.round(bitmap.width * sc)); c.height = Math.max(1, Math.round(bitmap.height * sc)); c.getContext('2d').drawImage(bitmap, 0, 0, c.width, c.height); }
      else { c.width = p[1]; c.height = p[1]; crop(bitmap, c, x, y, zoom); }
      return { name: p[0], canvas: c };
    });
    function blobs(q){ return Promise.all(canvases.map(function(f){ return new Promise(function(res, rej){ f.canvas.toBlob(function(b){ if(b && b.type === 'image/webp') res({ name: f.name, blob: b }); else rej(new Error('This browser cannot prepare WebP images. Try a newer browser.')); }, 'image/webp', q); }); })); }
    var qs = [0.84, 0.74, 0.64];
    function tryQ(i){ return blobs(qs[i]).then(function(files){ var total = files.reduce(function(n, f){ return n + f.blob.size; }, 0); if(total <= 1000000 || i === qs.length - 1){ if(total > 2000000) throw new Error('This image is still too large after compression. Choose a smaller image.'); return files; } return tryQ(i + 1); }); }
    return tryQ(0);
  }

  /* ---------------------------------------------------------------- sign in (the Hall's doors) */
  /* The Hall's own sign-in, step for step (hoh-your-hall.js: hohYhSignInEmailStep,
     hohYhSignInPinStep, hohYhSignInClaimStep). The email step asks two things at
     once: does this address own a hero (the R428 one-row author check, the Hall's
     own query), and does it have a PIN (email_has_pin). A hero and a PIN: enter it
     (verify_pin). A hero and no PIN yet: pick one (set_pin with a null old PIN,
     which the server refuses for an address that already has one). No hero: no PIN
     step at all. A check that cannot answer fails closed, like the Hall's. */
  var RL_KEY = 'hhp:signin-fails';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function emailKnown(email){
    function one(col){ return get('characters?select=id&' + col + '=eq.' + encodeURIComponent(email) + '&limit=1').then(function(r){ return (r && r.status >= 200 && r.status < 300 && Array.isArray(r.json)) ? r.json.length > 0 : null; }); }
    return Promise.all([one('auth_email'), one('email')]).then(function(q){
      if(q[0] === true || q[1] === true) return true;
      if(q[0] === null || q[1] === null) return null;
      return false;
    }, function(){ return null; });
  }
  function accountStep(email){
    email = String(email || '').trim().toLowerCase();
    if(!EMAIL_RE.test(email)) return Promise.resolve({ step: 'email', reason: 'invalid' });
    /* HALL-GOOGLE-01: and has the address signed in with Google (hoh-google-signin.js; false when it can't tell)?
       One with no PIN is offered Google first. */
    var google = window.hohGoogle ? window.hohGoogle.hint(email).catch(function(){ return false; }) : Promise.resolve(false);
    return Promise.all([emailKnown(email), call('email_has_pin', { user_email: email }), google]).then(function(r){
      var known = r[0], pin = r[1];
      if(known === null) return { step: 'cantcheck' };
      if(known === false) return { step: 'nomatch' };
      if(pin.ok && pin.data === true) return { step: 'pin' };
      if(!pin.ok) return { step: 'cantcheck' };
      if(r[2] === true) return { step: 'google' };
      return { step: 'claim' };
    });
  }
  function rlWait(email){ var rec = (store.get(RL_KEY, {}) || {})[email]; return rec && rec.n >= 5 ? Math.max(0, rec.at + 5 * 60000 - Date.now()) : 0; }
  function rlFail(email){ var rl = store.get(RL_KEY, {}) || {}, rec = rl[email] || { n: 0, at: 0 }; rl[email] = { n: (rec.n | 0) + 1, at: Date.now() }; store.set(RL_KEY, rl); }
  function rlClear(email){ var rl = store.get(RL_KEY, {}) || {}; delete rl[email]; store.set(RL_KEY, rl); }
  function verifyPin(email, pin){
    email = String(email || '').trim().toLowerCase(); pin = String(pin || '').trim();
    var wait = rlWait(email);
    if(wait > 0) return Promise.resolve({ ok: false, reason: 'wait', wait: wait });
    return call('verify_pin', { user_email: email, user_pin: pin }).then(function(ver){
      if(ver.network) return { ok: false, reason: 'network' };
      var n = (ver.ok && typeof ver.data === 'number') ? ver.data : 0;
      if(n > 0){ rlClear(email); saveToken(email, pin); return { ok: true }; }
      rlFail(email);
      var w = rlWait(email);
      return w > 0 ? { ok: false, reason: 'wait', wait: w } : { ok: false, reason: 'bad_pin' };
    });
  }
  function claimPin(email, pin){
    email = String(email || '').trim().toLowerCase(); pin = String(pin || '').trim();
    return call('set_pin', { user_email: email, old_pin: null, new_pin: pin }).then(function(r){
      if(r.network) return { ok: false, reason: 'network' };
      if(!r.ok || r.data === false) return { ok: false, reason: 'has_pin' };
      saveToken(email, pin);
      return { ok: true };
    });
  }
  /* the one-form sign in the page used before: the PIN step on its own */
  function signIn(email, pin){
    email = String(email || '').trim().toLowerCase();
    return verifyPin(email, pin).then(function(r){
      if(r.ok || r.reason !== 'bad_pin') return r;
      return call('email_has_pin', { user_email: email }).then(function(h){ return (h.ok && h.data === false) ? { ok: false, reason: 'no_pin' } : r; });
    });
  }

  /* ---------------------------------------------------------------- the judge (no AI) */
  /* A port of the approved prototype's judge (hub d-core.js). The server runs
     the same checks on every save; this copy lets the fill react as they type. */
  var FILLER = ['idk','i dont know',"i don't know",'dont know',"don't know",'dunno','n a','na','none','nothing','no','nope','yes','ok','okay','test','testing','test test','asdf','qwerty','lorem ipsum','blah','blah blah','whatever','tbd','tba','same','same as above','see above','xxx','no idea','not sure','nada','meh','hi','hello','idc','lol','nothing yet','not yet','later','skip','pass','none yet','nothing really','n/a','?'];
  var FILLER_SET = {}; FILLER.forEach(function(f){ FILLER_SET[f] = 1; });
  function normText(t){ return String(t || '').toLowerCase().replace(/[^\p{L}\p{N}\s']/gu, ' ').replace(/\s+/g, ' ').trim(); }
  function wordSet(t){ var o = {}; normText(t).split(' ').forEach(function(w){ if(w.replace(/'/g, '').length >= 3) o[w] = 1; }); return o; }
  function jaccard(a, b){ var ka = Object.keys(a), kb = Object.keys(b); if(ka.length < 3 || kb.length < 3) return 0; var inter = ka.filter(function(k){ return b[k]; }).length; return inter / (ka.length + kb.length - inter); }
  var GENERIC = {};
  ('i im ive ill id me my mine myself you youre your yours we us our they theyre them it its this that these those there here the a an and or but so if then than to of on in at for with about as by from into ' +
   'is are was were be been being am do does did done dont doesnt didnt havent hasnt isnt wasnt wont cant couldnt wouldnt shouldnt not no nope nah yes yeah yep ok okay sure ' +
   'really honestly actually just yet still now later soon maybe perhaps probably idk dunno know knows knowing think thinking thought guess idea ideas clue ' +
   'decide decided deciding undecided will would could should can might must fill add write figure out up come back go get ' +
   'nothing much anything something stuff thing things whatever all say said tell hi hello hey how what who why where when which ' +
   'test testing tests placeholder tbd tba na n etc blah lol haha hmm um uh well oh good fine great nice cool thanks thank please ' +
   'question questions answer answers very too also more some any none enough lets bit kind sort').split(' ').forEach(function(w){ GENERIC[w] = 1; });
  var STRONG_FILLER = /\b(idk|dunno|tbd|tba|asdf|lorem|n\/a|no idea|no clue)\b/;
  var UNDECIDED = /\b(decid\w*|undecided|not sure|later|yet)\b/;
  function contentWords(t, heroName){
    var name = {}; normText(heroName).split(' ').forEach(function(w){ if(w) name[w.replace(/'/g, '')] = 1; });
    return normText(t).split(' ').map(function(w){ return w.replace(/'/g, ''); }).filter(function(w){ return /\p{L}/u.test(w) && !GENERIC[w] && !name[w]; });
  }
  function judge(raw, others, echoes, heroName){
    var t = String(raw || '').trim();
    if(!t) return { ok: false, why: 'empty' };
    var norm = normText(t), low = t.toLowerCase().replace(/[‘’]/g, "'");
    var letters = (t.match(/\p{L}/gu) || []).length;
    var latin = (t.match(/[A-Za-zÀ-ɏ]/g) || []).length;
    var cjk = (t.match(/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/gu) || []).length;
    var words = t.split(/\s+/).filter(function(w){ return /\p{L}/u.test(w); });
    function fill(){ return { ok: false, why: UNDECIDED.test(low) ? 'undecided' : 'filler' }; }
    if(/(https?:\/\/|www\.|\b[a-z0-9-]+\.(com|net|org|io|gg|ly|co|me|app|xyz|dev|tv)\b)/i.test(t)) return { ok: false, why: 'link' };
    if(FILLER_SET[norm] || /^(lorem ipsum|asdf|qwer|idk\b)/.test(norm) || /^(test|testing|test test|test \d+)$/.test(norm)) return fill();
    if(/(\p{L})\1{3,}/u.test(t) || /([^\p{L}\s])\1{4,}/u.test(t)) return { ok: false, why: 'repeat' };
    if(latin){
      if(/[bcdfghjklmnpqrstvwxz]{7,}/i.test(t) || /(asdf|sdfg|dfgh|fghj|ghjk|hjkl|qwer|tyui|yuio|uiop|zxcv|xcvb|cvbn|vbnm)/i.test(t)) return { ok: false, why: 'mash' };
      var longW = words.filter(function(w){ return (w.match(/[A-Za-zÀ-ɏ]/g) || []).length >= 4; });
      var noVowel = longW.filter(function(w){ return !/[aeiouyàáâäãåèéêëìíîïòóôöõùúûü]/i.test(w); }).length;
      if(longW.length && noVowel / longW.length > 0.34) return { ok: false, why: 'mash' };
    }
    var upper = (t.match(/\p{Lu}/gu) || []).length;
    if(letters >= 12 && upper / letters > 0.7) return { ok: false, why: 'shout' };
    if(words.length >= 4){
      var u = {}; words.forEach(function(w){ u[w.toLowerCase().replace(/[^\p{L}]/gu, '')] = 1; });
      if(Object.keys(u).length / words.length < 0.5) return { ok: false, why: 'repeat' };
    }
    if(words.length < 8 && STRONG_FILLER.test(low)) return fill();
    if(!cjk && !contentWords(t, heroName).length) return fill();
    var mine = wordSet(t);
    for(var i = 0; i < (others || []).length; i++){
      var o = others[i];
      if(!o || !o.text) continue;
      if(normText(o.text) === norm || jaccard(mine, wordSet(o.text)) >= 0.8) return { ok: false, why: 'copy', ref: o.label, refId: o.id };
    }
    for(var e = 0; e < (echoes || []).length; e++){
      if(echoes[e] && (normText(echoes[e]) === norm || jaccard(mine, wordSet(echoes[e])) >= 0.6)) return { ok: false, why: 'echo' };
    }
    if(words.length < 4 && letters < 20 && cjk < 8) return { ok: false, why: 'short' };
    return { ok: true };
  }
  /* an idea counts once it is made the hero's own: at least 3 new detail words */
  function ideaClose(t, ideas, heroName){
    var mine = contentWords(t, heroName); if(!mine.length) return false;
    for(var i = 0; i < ideas.length; i++){
      var iw = {}; contentWords(ideas[i], heroName).forEach(function(w){ iw[w] = 1; });
      var fresh = mine.filter(function(w){ return !iw[w]; }).length;
      if(fresh < 3 && jaccard(wordSet(t), wordSet(ideas[i])) >= 0.4) return true;
      if(normText(t) === normText(ideas[i])) return true;
    }
    return false;
  }
  function judgeQ(cat, q, text, answers, heroName){
    var others = cat.questions.filter(function(o){ return o.id !== q.id && has(answers[o.id]); }).map(function(o){ return { id: o.id, text: answers[o.id], label: fillN(o.label, heroName) }; });
    var j = judge(text, others, [fillN(q.ask, heroName), fillN(q.help, heroName)], heroName);
    if(j.ok && ideaClose(text, q.ideas || [], heroName)) return { ok: false, why: 'idea' };
    return j;
  }
  /* blueprint details can be short ("Copper red"), so length is not asked for */
  function judgeBp(cat, f, text, heroName){
    if(!f) return { ok: false, why: 'empty' };
    if(f.kind === 'pick') return has(text) ? { ok: true } : { ok: false, why: 'empty' };
    var j = judge(text, [], [fillN(f.ask, heroName), fillN(f.help, heroName)], heroName);
    if(!j.ok && j.why === 'short') return { ok: true };
    return j;
  }
  function hintFor(j, heroName){
    var N = firstName(heroName);
    switch(j && j.why){
      case 'empty': return 'Write a few words, or tap Skip.';
      case 'short': return 'A few more words and this counts. Add a name, a place or a reason.';
      case 'filler': return 'That reads like a placeholder. Write it in a few real words, or tap Skip.';
      case 'undecided': return 'Not sure yet? Tap Skip. It costs nothing, and the question comes back later.';
      case 'repeat': return 'Looks like a key got stuck. Write it out in a few real words and it counts.';
      case 'mash': return 'That looks like a keyboard mash. A few real words will count.';
      case 'shout': return 'Try it without all caps. The same words in normal case count.';
      case 'link': return "Links don't count here. Say it in your own words.";
      case 'copy': return 'That matches your answer to "' + (j.ref || 'another question') + '". Give this one its own detail.';
      case 'echo': return 'That repeats the question. Answer it in your own words.';
      case 'idea': return "That's the example. Change a name, a place or a reason to make it " + poss(N) + ' and it counts.';
      case 'too_long': return 'That is longer than this answer can hold. Trim it a little.';
    }
    return 'Try a few more real words.';
  }

  /* ---------------------------------------------------------------- scoring model */
  /* The page's picture of the server's score, rebuilt from the catalog, the
     stored answers and the server's own blueprint count. Used for the plan
     and the "+N" preview only. What the page SHOWS as tier and points is the
     server's rarity, every time. */
  function model(cat, pg){
    var h = pg.hero || {}, answers = {};
    Object.keys(pg.answers || {}).forEach(function(id){ answers[id] = pg.answers[id].text; });
    /* R805: the hero's own ladder, so idx, disp and every plan index into the steps this hero shows
       (the requirements at each index are the catalog's, whichever ladder it is) */
    var c = heroCat(cat, pg.rarity.ff);
    return {
      cat: c, name: h.name || '', answers: answers, bp: (pg.blueprint && pg.blueprint.fields) || {},
      essentials: !!((h.image_url || h.image_thumb_url) && has(h.name) && has(h.race) && has(h.character_class)),
      bpServer: pg.rarity.bp_filled, bpComplete: !!pg.rarity.bp_complete,
      floor: tierIndexOf(c, pg.rarity.stored), mythic: !!pg.rarity.mythic, ff: !!pg.rarity.ff
    };
  }
  function tierIndexOf(cat, k){ for(var i = 0; i < cat.tiers.length; i++){ if(cat.tiers[i].k === k) return i; } return k === 'mythic' ? cat.tiers.length - 1 : 0; }
  function bpCounts(m, k){ var f = m.cat.f[k]; return !!(f && has(m.bp[k]) && judgeBp(m.cat, f, m.bp[k], m.name).ok); }
  function bpFilled(m){
    var local = m.cat.bpReq.filter(function(f){ return bpCounts(m, f.k); }).length;
    return (m.bpServer != null && m.bpServer !== local) ? m.bpServer : local;
  }
  function bpPts(n, of){ of = of || 9; return Math.round(10 * Math.min(of, n) / of); }
  function meets(T, total, withInfo, coreAll, bpDone){ return total >= T.min && (!T.breadth || withInfo >= T.breadth) && (!T.core || coreAll) && (!T.bp || bpDone); }
  function computeAll(m, opt){
    opt = opt || {};
    var cat = m.cat, raw = {};
    cat.sections.forEach(function(s){ raw[s.k] = 0; });
    if(m.essentials) raw.id = (raw.id || 0) + cat.endowed;
    cat.questions.forEach(function(q){ if(has(m.answers[q.id]) || opt.extra === q.id) raw[q.p] = (raw[q.p] || 0) + q.pts; });
    var of = cat.bpReq.length || 9;
    var bpn = Math.min(of, bpFilled(m) + (opt.extraBp && !bpCounts(m, opt.extraBp) && m.cat.f[opt.extraBp] && m.cat.f[opt.extraBp].req ? 1 : 0));
    raw.bp = bpPts(bpn, of);
    var pts = {}, total = 0, withInfo = 0, coreAll = true;
    cat.sections.forEach(function(s){ pts[s.k] = Math.min(s.cap, raw[s.k] || 0); total += pts[s.k]; if(pts[s.k] > 0) withInfo++; else if(s.core) coreAll = false; });
    var bpDone = m.bpComplete || bpn >= of;
    var idx = 0; cat.tiers.forEach(function(T, i){ if(i > 0 && meets(T, total, withInfo, coreAll, bpDone)) idx = i; });
    var disp = Math.max(idx, m.floor || 0);
    return { raw: raw, pts: pts, total: total, withInfo: withInfo, coreAll: coreAll, bpn: bpn, bpDone: bpDone, idx: idx, disp: disp, mythic: m.mythic };
  }
  function marginal(m, q, sc){ return Math.min(m.cat.sec[q.p].cap, (sc.raw[q.p] || 0) + q.pts) - sc.pts[q.p]; }
  /* The fewest steps that reach tier ti (prototype planFor). A step is one
     answer or one blueprint detail. Missing sections first, then the biggest
     gains. Legendary always asks for the full blueprint. */
  function planFor(m, ti, sc, skipped){
    var cat = m.cat, T = cat.tiers[ti]; if(!T) return [];
    skipped = skipped || {};
    var sim = {}; Object.keys(sc.raw).forEach(function(k){ sim[k] = sc.raw[k]; });
    var of = cat.bpReq.length || 9, bpn = sc.bpn, steps = [], usedQ = {}, usedB = {};
    function capped(k){ return k === 'bp' ? bpPts(bpn, of) : Math.min(cat.sec[k].cap, sim[k] || 0); }
    function tot(){ return cat.sections.reduce(function(a, s){ return a + capped(s.k); }, 0); }
    function info(){ return cat.sections.filter(function(s){ return capped(s.k) > 0; }).length; }
    function nextBp(){ for(var i = 0; i < cat.bpReq.length; i++){ var f = cat.bpReq[i]; if(!bpCounts(m, f.k) && !usedB[f.k]) return f; } return null; }
    function takeBp(){ var f = nextBp(); if(!f) return false; usedB[f.k] = 1; bpn++; steps.push({ kind: 'bp', f: f }); return true; }
    for(var guard = 0; guard < 80; guard++){
      var needCore = T.core ? cat.sections.filter(function(s){ return s.core && capped(s.k) === 0; }).map(function(s){ return s.k; }) : [];
      var needAny = !!(T.breadth && info() < T.breadth);
      var needBp = !!(T.bp && bpn < of && !m.bpComplete);
      if(tot() >= T.min && !needCore.length && !needAny && !needBp) return steps;
      if(needBp && tot() >= T.min - (bpPts(of, of) - bpPts(bpn, of)) && !needCore.length){ if(takeBp()) continue; }
      var cands = cat.questions.filter(function(q){ return !has(m.answers[q.id]) && !usedQ[q.id]; });
      if(needCore.length) cands = cands.filter(function(q){ return needCore.indexOf(q.p) >= 0; });
      else if(needAny) cands = cands.filter(function(q){ return capped(q.p) === 0; });
      var best = null, bm = 0;
      cands.forEach(function(q){
        var mg = Math.min(cat.sec[q.p].cap, (sim[q.p] || 0) + q.pts) - capped(q.p);
        if(mg > bm || (mg === bm && best && (skipped[best.id] && !skipped[q.id]))){ bm = mg; best = q; }
      });
      var bpGain = bpn < of ? bpPts(bpn + 1, of) - bpPts(bpn, of) : 0;
      var bpAllowed = !needCore.length && (!needAny || capped('bp') === 0);
      if(bpAllowed && bpGain > bm){ if(takeBp()) continue; }
      if(!best){ if(bpAllowed && bpGain > 0 && takeBp()) continue; if(needBp && takeBp()) continue; return null; }
      usedQ[best.id] = 1; sim[best.p] = (sim[best.p] || 0) + best.pts; steps.push({ kind: 'q', q: best });
    }
    return null;
  }
  /* the next question after the first ten: missing sections first, quick first, bigger gains first */
  function nextEasiest(m, sc, skipped, avoidSkipped){
    skipped = skipped || {};
    var c = m.cat.questions.filter(function(q){ return !has(m.answers[q.id]) && marginal(m, q, sc) > 0 && !(avoidSkipped && skipped[q.id]); });
    if(!c.length) return null;
    c.sort(function(a, b){
      return ((sc.pts[a.p] === 0 ? 0 : 1) - (sc.pts[b.p] === 0 ? 0 : 1)) || ((a.eff === 'q' ? 0 : 1) - (b.eff === 'q' ? 0 : 1)) || (marginal(m, b, sc) - marginal(m, a, sc)) || (a.order - b.order);
    });
    return c[0];
  }

  /* ---------------------------------------------------------------- quips (pre-written, no AI) */
  /* C18: a short aside after each save, in Jan's plain voice. Picked by hash so
     the same answer always gets the same line and two in a row rarely match. */
  var QUIPS = {
    sentence: ['That is how a hero gets introduced.', 'Short, sharp and tavern ready.', 'Anyone could pull up a chair after that line.'],
    want: ['Now the DM has something to dangle.', 'A goal on the table. The plot thickens.', 'Every good session starts with a want like that.'],
    matters: ['Someone to protect. Or to kidnap, if the DM is cruel.', 'Every hero needs a name to shout across a battlefield.', 'That name is going to come up again.'],
    why: ['So that is why they left the warm bed behind.', 'A reason to keep walking. Good.', 'That one explains a lot of choices.'],
    visual: ['An artist could start sketching with that.', 'The detail everyone will remember. Noted.', 'That is the first thing a painter looks for.'],
    flaw: ['Flaws make the best stories.', 'Trouble, written down for later.', 'The party is going to love and hate that.'],
    protect: ['Now everyone knows what is at stake.', 'Threaten that and watch the dice fly.', 'A line in the sand. Good to know where it is.'],
    unfinished: ['That is a loose thread a DM will pull.', 'Some doors never quite close.', 'Bad news for later, good news for the story.'],
    bringback: ['Old faces make the best surprises.', 'Noted for a dramatic return.', 'The past has a way of knocking twice.'],
    habit: ['Easy to play at the table. Try it next session.', 'Two seconds to slip into character. Perfect.', 'Now everyone knows it is them before they speak.']
  };
  var QUIPS_ANY = ['Another page of the legend.', 'The Hall just got a little richer.', 'That one reads well out loud.', 'Specific beats long, and that was specific.', 'The page just got more interesting.', 'Good detail. That is the kind people remember.'];
  var QUIPS_BP = ['One step closer to a painting.', 'An artist would thank you for that.', 'That is exactly what a painter asks first.', 'Filed under details that make the portrait.'];
  function quip(kind, id, seed){
    var pool = kind === 'bp' ? QUIPS_BP : ((QUIPS[id] || []).concat(QUIPS_ANY));
    return pool[hash(String(id) + '|' + seed) % pool.length];
  }

  /* ---------------------------------------------------------------- dates */
  function monthYear(iso){ try { var d = new Date(iso); if(isNaN(d.getTime())) return ''; return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }); } catch(_){ return ''; } }
  function shortDate(iso){ try { var d = new Date(iso); if(isNaN(d.getTime())) return ''; return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); } catch(_){ return ''; } }
  function dayMonth(iso){ try { var d = new Date(iso); if(isNaN(d.getTime())) return ''; return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); } catch(_){ return ''; } }
  function localTime(iso){ try { var d = new Date(iso); if(isNaN(d.getTime())) return ''; return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); } catch(_){ return ''; } }

  /* ---------------------------------------------------------------- lazy modules */
  var loading = {};
  function loadScript(url){
    if(!url) return Promise.reject(new Error('missing'));
    if(loading[url]) return loading[url];
    loading[url] = new Promise(function(resolve, reject){
      var s = document.createElement('script'); s.src = url; s.async = true;
      s.onload = function(){ resolve(); }; s.onerror = function(){ delete loading[url]; reject(new Error('load')); };
      document.head.appendChild(s);
    });
    return loading[url];
  }
  function module(name){ var url = CFG.assets[name]; return loadScript(url); }

  window.HHD = {
    cfg: CFG, esc: esc, has: has, clamp: clamp, plural: plural, hash: hash, safeUrl: safeUrl, uuid: uuid, UUID_RE: UUID_RE,
    firstName: firstName, poss: poss, fillN: fillN, joinAnd: joinAnd, store: store,
    token: token, signIn: signIn, call: call, door: door, get: get, send: send, isMissing: isMissing,
    storedEmail: storedEmail, accountStep: accountStep, verifyPin: verifyPin, claimPin: claimPin, EMAIL_RE: EMAIL_RE,
    doors: DOORS, catalog: catalog, normCatalog: normCatalog, normPage: normPage, normOwner: normOwner, normRarity: normRarity, normBlueprint: normBlueprint, normTitle: normTitle,
    tierKey: tierKey, TIER_KEYS: TIER_KEYS, TIER_NAMES: TIER_NAMES, legacyTier: legacyTier, heroCat: heroCat, hallTier: hallTier, BP_DEFAULT: BP_DEFAULT,
    titleRoll: titleRoll, heroFallback: heroFallback, resolveId: resolveId, moreHeroes: moreHeroes, cardNeedsText: cardNeedsText, cardTextAsk: cardTextAsk,
    artworks: artworks, removedArt: removedArt, artAction: artAction, uploadArt: uploadArt, purgeArt: purgeArt, reframe: reframe, framing: framing, imgStyle: imgStyle, crop: crop, prepareImages: prepareImages,
    judge: judge, judgeQ: judgeQ, judgeBp: judgeBp, hintFor: hintFor, contentWords: contentWords,
    normTitleOwn: normTitleOwn, oneLine: oneLine, chars: chars, judgeOwnTitle: judgeOwnTitle,
    model: model, computeAll: computeAll, planFor: planFor, nextEasiest: nextEasiest, tierIndexOf: tierIndexOf, bpPts: bpPts, bpCounts: bpCounts, marginal: marginal,
    quip: quip, monthYear: monthYear, shortDate: shortDate, dayMonth: dayMonth, localTime: localTime,
    loadScript: loadScript, module: module
  };
})();
